module.exports = __webpack_public_path__ + "static/media/saro.22ade9db.png";